import Vue from 'vue'

// 返回是否有优惠内容
// 传入 skuId 时才会检查是否有拼团优惠
export function hasDiscount(data: any, skuId?: string) {
  return (
    data &&
    typeof data === 'object' &&
    (false ||
      // 优惠券
      data.fullCoupons?.length ||
      // 折扣优惠
      data.discounts?.length ||
      // 渠道优惠
      data.payChannels?.length ||
      // 抵扣方式
      data.channelIntegrals?.length ||
      // 拼团
      (skuId &&
        data.groupBuying?.skuInfos?.find((sku: any) => sku.skuId === skuId)
          ?.ladderConfig?.length) ||
      // 满减优惠
      data.fullReductions?.length ||
      //折扣券
      // data.marketingDiscountCoupons?.length ||
      // TODO
      false)
  )
}

Vue.prototype.$hasDiscount = hasDiscount
